// src/GroupedBarChart.js
import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

// Modern color palette with shades of blue and teal
const COLORS = [
  '#3f51b5', '#00bcd4', '#009688', '#4caf50', 
  '#ff9800', '#e91e63', '#9c27b0', '#2196f3',
  '#ff5722', '#607d8b', '#795548', '#f44336'
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.95)', 
        border: '1px solid #e0e0e0', 
        padding: '15px', 
        borderRadius: '10px', 
        boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
        backdropFilter: 'blur(5px)',
        minWidth: '200px'
      }}>
        <p style={{ 
          margin: 0, 
          fontWeight: 'bold', 
          paddingBottom: '10px', 
          borderBottom: '1px solid #eee', 
          color: '#3f51b5',
          fontSize: '0.95rem'
        }}>
          {label}
        </p>
        <ul style={{ 
          paddingLeft: 0, 
          listStyle: 'none', 
          marginTop: '8px',
          maxHeight: '300px',
          overflowY: 'auto'
        }}>
          {payload.map((pld, index) => (
            <li key={index} style={{ 
              color: pld.fill, 
              margin: '8px 0', 
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ 
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: pld.fill,
                borderRadius: '2px',
                marginRight: '8px'
              }}></span>
              <span style={{ flexGrow: 1 }}>{pld.name}</span>
              <span style={{ fontWeight: 600 }}>฿{pld.value.toLocaleString()}</span>
            </li>
          ))}
          <li style={{ 
            marginTop: '10px',
            paddingTop: '10px',
            borderTop: '1px solid #eee',
            fontWeight: 'bold',
            color: '#37474f',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <span>รวมทั้งหมด:</span>
            <span>฿{payload.reduce((sum, item) => sum + item.value, 0).toLocaleString()}</span>
          </li>
        </ul>
      </div>
    );
  }
  return null;
};

const GroupedBarChart = ({ data, subjects }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ 
        height: 400, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        color: '#90a4ae', 
        fontSize: '1.1rem',
        background: 'rgba(245, 248, 250, 0.6)',
        borderRadius: '12px',
        border: '1px dashed #cfd8dc'
      }}>
        ไม่มีข้อมูลสำหรับตัวกรองที่เลือก
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={500}>
      <BarChart 
        data={data} 
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        barCategoryGap={15}
        barGap={5}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
        <XAxis 
          dataKey="name" 
          tick={{ fontSize: 12, fill: '#546e7a' }} 
          axisLine={false}
          tickLine={false}
        />
        <YAxis 
          tickFormatter={(value) => `${value/1000}k`} 
          tick={{ fontSize: 12, fill: '#546e7a' }} 
          axisLine={false}
          tickLine={false}
        />
        <Tooltip 
          content={<CustomTooltip />} 
          cursor={{ fill: 'rgba(63, 81, 181, 0.05)' }}
          wrapperStyle={{ zIndex: 1000 }}
        />
        <Legend 
          verticalAlign="top" 
          height={60}
          iconType="circle"
          iconSize={10}
          wrapperStyle={{ paddingBottom: '10px' }}
        />
        {subjects.map((subject, index) => (
          <Bar
            key={subject}
            dataKey={subject}
            fill={COLORS[index % COLORS.length]}
            name={subject}
            radius={[4, 4, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GroupedBarChart;